import courseDetailsLocale from './en.json'

const en = {
  courseDetails: courseDetailsLocale,
}

export default en
